module.exports = __webpack_public_path__ + "img/red.a5b265c3.jpg";